import {connect} from "react-redux";
import { actions } from '../../Action';
import { actions as businessCardActions , selectors as businessCardSelectors } from '../../BusinessCard';
import ActionsPanel from './ActionsPanel';

const {removeCardAction, addCardAction , getCardAction , setActions , updateCardAction} = actions;
const { editCardSetting } = businessCardActions;
const { getCardActions , getCardSettings , getClientInfo } = businessCardSelectors;


const mapDispatchToProps = (dispatch) => {
    return {
        removeAction: (actionToRemoveId,position) => dispatch(removeCardAction(actionToRemoveId,position)),
        addCardAction: actionToAdd => dispatch(addCardAction(actionToAdd)),
        updateAction: updatedAction => dispatch(updateCardAction(updatedAction)),
        getCardAction: actionName => dispatch(getCardAction(actionName)),
        setCardActions: (actions) => dispatch(setActions(actions)),
        editCardSetting: (level,setting,value) => dispatch(editCardSetting(level,setting,value))
    }
}

const mapStateToProps = (state) => {
    return {
        actions: getCardActions(state),
        cardSettings: getCardSettings(state),
        clientInfo: getClientInfo(state)
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(ActionsPanel);